import { SSP_BID_TIMEOUT_MS, SSP_BID_URL } from "../constants";

// SSP не конвертирует валюту, а повторяет запрошенную: поэтому константа, а не параметр.
export const SSP_CURRENCY = "RUB";

export const BID_OK = "ok";
export const BID_NONE = "nobid";
export const BID_TIMEOUT = "timeout";
export const BID_ERROR = "error";

function currentWindowSize() {
    if (typeof window === "undefined") {
        return { width: 0, height: 0 };
    }

    return { width: window.innerWidth, height: window.innerHeight };
}

export function buildSspBidRequest({ blockId, sizes }, windowSize = currentWindowSize()) {
    return {
        // id — эхо для сопоставления ответа (`bids[].id`), с DOM не связан:
        // displayCode создаёт свой div.
        places: [{ id: `ssp-${blockId}`, placementId: String(blockId), sizes: sizes || [] }],
        settings: { currency: SSP_CURRENCY, windowSize },
    };
}

function result(status, bids = []) {
    return { status, bids };
}

function requestBid(ssp, { fetchImpl, signal, windowSize }) {
    return fetchImpl(SSP_BID_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        // С cookie smi_uid посетителя в аукцион попадают данные cookie-sync.
        credentials: "include",
        body: JSON.stringify(buildSspBidRequest(ssp, windowSize)),
        signal,
    })
        .then((response) => {
            if (response.status === 204) {
                return result(BID_NONE);
            }

            if (response.status !== 200) {
                return result(BID_ERROR);
            }

            return response.json().then(
                (body) => result(BID_OK, body && Array.isArray(body.bids) ? body.bids : []),
                () => result(BID_ERROR)
            );
        })
        .catch(() => result(BID_ERROR));
}

/**
 * Ставка RTB на один показ: `{status: ok | nobid | timeout | error, bids}`.
 *
 * Исключений наружу нет: любой отказ — это статус, по которому аукцион отдаёт место
 * сопернику. Ответ, пришедший после таймаута, игнорируется.
 */
export function fetchSspBid(ssp, { fetchImpl, timeoutMs = SSP_BID_TIMEOUT_MS, windowSize } = {}) {
    const doFetch = fetchImpl || (typeof fetch === "undefined" ? null : fetch);
    if (!doFetch) {
        return Promise.resolve(result(BID_ERROR));
    }

    const controller = typeof AbortController === "undefined" ? null : new AbortController();
    let timer = null;

    const timeout = new Promise((resolve) => {
        timer = setTimeout(() => {
            if (controller) {
                controller.abort();
            }
            resolve(result(BID_TIMEOUT));
        }, timeoutMs);
    });

    const request = requestBid(ssp, {
        fetchImpl: doFetch,
        signal: controller ? controller.signal : undefined,
        windowSize: windowSize || currentWindowSize(),
    });

    return Promise.race([request, timeout]).then((outcome) => {
        clearTimeout(timer);

        return outcome;
    });
}
